import React from "react";
import RNF from "../../assets/RNF.png";

const ResultNotFound = () => {
  return (
    <div className="container d-flex justify-content-center align-items-center h-100">
      <div className="m-5">
        <img className="w-100 mb-5" src={RNF} alt="not Found" />
        <h3 className="text-center">Result not Found</h3>
      </div>
    </div>
  );
};

export default ResultNotFound;
